import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {StoreContext} from "../../stores/contexts";

class PageNavigation extends Component {
  static contextType = StoreContext;

  render() {
    const pages=this.context.dataStore.data.data.pages;
    if(pages) {
      return (
        <div className="up12 splice pagesGrid">
          <div className="cell s-shrink pright10 s-middle pagesWrap">
            {pages.links.map((item,index)=>{
              if(item === '-') {
                return (
                  <span className="dib padd5 pageItem pageDots" key={index}>...</span>
                );
              }
              if(item.sel) {
                return (
                  <span className="dib padd5 bg-w1 solid1 bo-w3 pageItem pageSelected" key={index}>{item.page}</span>
                )
              }
              return (
                <a key={index} onClick={(e)=>{ e.preventDefault(); this.context.memoryStore.setPage(item.page); }} className="pageItem dib padd5" href={item.url}>{item.page}</a>
              )
            })}
          </div>
          <div className="cell s-shrink s-middle prevBtnWrap">
            {pages.prev_page_url?(
              <a href={pages.prev_page_url} onClick={(e)=>{ e.preventDefault(); this.context.memoryStore.setPage(pages.prev_page); }} className="btn2"><span><i className="b1 mdi mdi-chevron-left only"></i></span></a>
            ):(
              <span className="btn2"><span><i className="mdi mdi-chevron-left only op50"></i></span></span>
            )}
          </div>
          <div className="cell s-shrink s-middle nextBtnWrap">
            {pages.next_page_url?(
              <a href={pages.next_page_url} onClick={(e)=>{ e.preventDefault(); this.context.memoryStore.setPage(pages.next_page); }} className="btn2"><span><i className="b1 mdi mdi-chevron-right only"></i></span></a>
            ):(
              <span className="btn2"><span><i className="mdi mdi-chevron-right only op50"></i></span></span>
            )}
          </div>
        </div>
      )
    }
    return null;
  }
}

// export default inject("dataStore","memoryStore")(observer(PageNavigation));
export default observer(PageNavigation);